import { render, staticRenderFns } from "./WCheckbox.vue?vue&type=template&id=7153fa00&scoped=true"
import script from "./WCheckbox.vue?vue&type=script&lang=js"
export * from "./WCheckbox.vue?vue&type=script&lang=js"
import style0 from "./WCheckbox.vue?vue&type=style&index=0&id=7153fa00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7153fa00",
  null
  
)

export default component.exports